/**
 * Read Aloud sentence catalogue (server-controlled reference text, FR-70).
 * The client sends `passageId` + `sentenceIndex`; it never sends reference
 * text. Proper nouns are declared here so FR-75 can exclude them.
 *
 * The pre-authored KT1 sentences, unchanged. They are UNREVIEWED pilot
 * content (FR-171): served only to the D-20 pilot family (checked by
 * `claim_read_aloud`) and labelled as pilot content in the app. The app keeps
 * a copy for display (`src/platform/read-aloud/passages.ts`, checked equal by
 * a test). Not AI-generated; no Cambridge alignment is claimed.
 */

export interface Passage {
  id: string
  title: string
  sentences: readonly string[]
  properNouns: readonly string[]
}

export const PASSAGES: readonly Passage[] = [
  {
    id: 'kt1-fox',
    title: 'The little fox',
    sentences: [
      'The little fox jumped over the wooden fence.',
      'It ran into the green forest to find its friends.',
      'Mia saw the fox from her bedroom window.',
    ],
    properNouns: ['Mia'],
  },
  {
    id: 'kt1-school',
    title: 'Going to school',
    sentences: [
      'Every morning Tom walks to school with his sister.',
      'They pass a small bakery on the corner.',
      'On rainy days they carry a big yellow umbrella.',
    ],
    properNouns: ['Tom'],
  },
  {
    id: 'kt1-park',
    title: 'In the park',
    sentences: [
      'After school the children play in the park.',
      'Their dog Max runs after a red ball.',
      'In the evening they read a book together.',
    ],
    properNouns: ['Max'],
  },
]

export function findSentence(
  passageId: string,
  sentenceIndex: number,
): { text: string; properNouns: readonly string[] } | null {
  const passage = PASSAGES.find((p) => p.id === passageId)
  if (passage === undefined || !Number.isInteger(sentenceIndex)) return null
  const text = passage.sentences[sentenceIndex]
  return text === undefined ? null : { text, properNouns: passage.properNouns }
}
